export const GRAPH_HEIGHT = 200;
